import type { ApplicationApi } from "./applicationApi";

export interface ReconciliationRun {
  as_of_date: string;
  created_at: string;
  exception_count: number;
  id: string;
  item_count: number;
  status: string;
  total_variance: string;
}

export interface ReconciliationItem {
  balance_type: string;
  explanations: Array<{ created_at: string; explanation: string; id: string }> | null;
  id: string;
  loan_name: string;
  loan_number: string;
  resolution: Record<string, unknown> | null;
  sage_amount: string;
  status: string;
  subledger_amount: string;
  variance_amount: string;
}

export function getReconciliationView<T>(api: ApplicationApi, view: string, parameters: Record<string, string> = {}): Promise<T> {
  return api.get<T>(`reconciliation-operations?${new URLSearchParams({ view, ...parameters }).toString()}`);
}

export function performReconciliationAction<T>(api: ApplicationApi, body: Record<string, unknown>): Promise<T> {
  return api.post<T, Record<string, unknown>>("reconciliation-operations", body);
}